export const TAGS = [
    "复刻塔", "处女作", "悬赏塔", "高难塔", "剧情向", "加点塔", "转换塔", "道具塔", "境界塔", "技能塔", "平面塔", "连载塔", "机关塔", "小游戏"
];

export const COLORS = [
    { name: '白', value: '#F1F1F1', primary: '#607D8B' },
    { name: '橙', value: '#FFC088', primary: '#FF9800' },
    { name: '蓝', value: '#ADD8E6', primary: '#2196F3' },
    { name: '绿', value: '#90EE90', primary: '#4CAF50' },
    { name: '红', value: '#FF9999', primary: '#F44336' },
    { name: '紫', value: '#DED0ff', primary: '#673AB7' },
]

export const NULL_AVATAR = "https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png";

export const ERROR_CODE = {
    "-2": "录像运行成功，但是结果和上传成绩不一致。",
    "1" : "未处理的脚本错误。",
    "10" : "录像运行出错。",
    "15" : "录像运行超时。",
    "16" : "意外中断的录像，有可能是回调链断裂。",
}